// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid-module--grid--27PSu","colSpan2":"Grid-module--colSpan2--euuN5"};